import * as React from 'react';
import { Image } from 'antd';
import URI from 'urijs';
export const PointIconsColorOnWhite = (props) => {
    var _a;
    return (React.createElement(Image, Object.assign({}, props, { height: props.width ? 'auto' : 'unset', src: `https://sf-assets.${(_a = props.domainOverride) !== null && _a !== void 0 ? _a : new URI(location.href).domain()}/illustrations/PointIconsColorOnWhite.svg`, preview: false, alt: "" })));
};
